// Imports
import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { Routes, Route, Navigate } from 'react-router-dom';

// Views
import MainView from './views/main';

import DriverDetailView from './views/driverDetail';
import VehicleDetailView from './views/vehicleDetail';
import ServiceDetailView from './views/serviceDetail';
import { HasPermission } from '../../core/security';

// Router
const routerMaintenance = (props) => {

    const user = useSelector(state => state.securityRedux.user);
    return (
        <Routes>
            {
                HasPermission(user, "mntnnc-beta", [213]) &&
                <Fragment>
                    <Route path='/' element={<Navigate to="/app/maintenances/main" />}></Route>
                    <Route path='vehicleDetail/:id' element={<VehicleDetailView />} />
                    <Route path='serviceDetail/:id' element={<ServiceDetailView />} />
                    <Route path='driverDetail/:id' element={<DriverDetailView />} />
                    <Route path='main' element={<MainView />} />
                    <Route path='main/:id' element={<MainView />} />
                </Fragment>
            }
            <Route path="*" element={<Navigate to="/app/error" />} />
        </Routes>
    );
};

export default routerMaintenance
